export { ServerancePayRegister } from './ServerancePayRegister';
